@if (isLoading()) {
<div class="card">
  <div class="card-header">
    <h6 class="m-0 placeholder-glow">
      <span class="placeholder rounded col-3"></span>
    </h6>
  </div>

  <div class="row g-3 m-2 mb-3 placeholder-glow">
    @for (i of [0,1,2]; track i) {
    <div class="col-12 col-md-4">
      <div class="doc-main d-flex align-items-center gap-2">
        <span
          class="placeholder rounded"
          style="width: 260px; height: 56px; display: inline-block"
        ></span>
      </div>
    </div>
    }
  </div>
</div>
} @else {
<div class="card">
  <div class="card-header">
    <h6 class="m-0">
      {{ "admin.projectIdeas.details.documentsTitle" | translate }}
    </h6>
  </div>

  <app-attachment-list [files]="files()" [loading]="isLoading()" />
</div>
}
